import React, { useEffect, useState } from "react";
import Header from "./header";
import ShowFilterCard from "./filter_card";
import GovtJobTable from "./govt_job_table";
import { FixedSizeList } from 'react-window';
import { LinearProgress } from '@mui/material';
import { trackPageVisit } from '../../utils/analytics';

// function getItemSize() {
//   }

function JobSearch() {
  //making parent component variable to be sharable between filter and table component
  const [filteredJobs, setFilteredJobs] = useState([""]);
  const updateFilteredJobs = (jobs) => {
    setFilteredJobs(jobs)
  }

  const [loadingState, updateLoadingState] = useState(false);
  const changeLoadingState = (value) => {
    updateLoadingState(value);
  }

  const [showTable, updateShowTable] = useState(false);
  const changeShowTable = (value) => {
    updateShowTable(value);
  }

  useEffect(() => {
    // Track page visit when component mounts
    trackPageVisit('jobsearch');
    
    return () => {
      // Cleanup if needed
    };
  }, []);

  function getTotalVacancy(variable) {
    if (Array.isArray(variable)) {
      return variable.reduce((acc, curr) => parseInt(acc) + parseInt(curr), 0);
    } else {
      return variable;
    }
  }

  const rowRenderer = ({ index, style }) => (
    <div style={style}>
      <GovtJobTable postLink={String(filteredJobs[index]["title"]).replace(/\s+/g, '_')} job={filteredJobs[index]["exam_name"]} application_last_date={filteredJobs[index]["application_last_date"]} total_vacancies={getTotalVacancy(filteredJobs[index]["total_vacancies"])} />
    </div>
  );

  return <div>
    <Header />
    <div className="body_content">
      <br /><br /><br /><br />
      <ShowFilterCard updateFilteredJobs={updateFilteredJobs} changeLoadingState={changeLoadingState} showTable={changeShowTable} />
      <br />
      <div className="card">
        {
          showTable ? <div>
            {loadingState ? <LinearProgress /> : null}   <FixedSizeList
              height={600}
              itemCount={filteredJobs.length}
              itemSize={80}
              width="100%"
            >
              {rowRenderer}
            </FixedSizeList>
          </div> : <p>Select options and click on "Find Jobs"!      </p>

        }


      </div>
      <br /><br /><br /><br />
    </div>
  </div>
}

export default JobSearch;